import type { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import type { RootState } from "@store/store";
import { FACULTY_HOME_ROUTE, isFacultyAllowedRoute, isFacultyUser } from "@utils/facultyAccess";

interface FacultyAccessGuardProps {
	children: ReactNode;
}

/**
 * Restricts faculty users to Student Attendance, Promotion, Dropout, Employment Status, Result Management, Session Students, and Student Certificates.
 * Institute and other user types are unaffected.
 */
const FacultyAccessGuard: FC<FacultyAccessGuardProps> = ({ children }) => {
	const user = useSelector((state: RootState) => state.user.user);
	const token = useSelector((state: RootState) => state.user.token);
	const location = useLocation();

	if (isFacultyUser(user, token) && !isFacultyAllowedRoute(location.pathname)) {
		return <Navigate to={FACULTY_HOME_ROUTE} replace />;
	}

	return <>{children}</>;
};

export default FacultyAccessGuard;
